import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-student-online-lessons',
    templateUrl: './student-online-lessons.component.html',
    styleUrls: ['./student-online-lessons.component.css'],
    standalone: false
})
export class StudentOnlineLessonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
